<template>
    <button
        :class="{'ui-text-underline-btn': true, active }"
        @click="$emit('click')"
    >
        <span>{{ labelText }}</span>
    </button>
</template>

<script>
import VueTypes from "vue-types";

export default {
    name: "MyTextUnderlineBtn",
    props: {
        labelText: VueTypes.string,
        active: VueTypes.bool.def(false),
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>